import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../../../app/hooks/useAuth";
import {
  AclModule,
  ServiceType,
  UserTypes,
} from "../../../features/constants/commonEnum";
import VoiceButton from "../../../features/components/customComponents/CustomVoiceButton";
import { toggleAside } from "../../../app/utils/utils.js";
import { setCentricUser } from "../../../app/redux/slices/app/userDetailsSlice";
import { setActivatebot } from "../../../app/redux/slices/app/chatBotSlice";

const LeftMenu = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { getAcl } = useAuth();
  const navigate = useNavigate();

  const { selectedAccount, userAccountDetails } = useSelector(
    (state) => state?.userDetailSlice,
  );

  const [userLoginInfo, setuserLoginInfo] = useState(null);
  const [userAccountInfo, setuserAccountInfo] = useState(null);

  useEffect(() => {
    setuserLoginInfo(userAccountDetails?.userLoginInfo);
    setuserAccountInfo(userAccountDetails?.userAccountInfo);
  }, [userAccountDetails]);

  const [isFiberSubmenuOpen, setIsFiberSubmenuOpen] = useState(false);
  const chatActivate =
    useSelector((state) => state?.chatBotSlice?.commonBotActivate) || false;

  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [opensubSubmenu, setOpenSubsubmenu] = useState(null);
  const toggleSubmenu = (key) => {
    setOpenSubmenu((prev) => (prev === key ? null : key));
  };
  const toggleSubsubmenu = (key) => {
    setOpenSubsubmenu((prev) => (prev === key ? null : key));
  };
  useEffect(() => {
    if (location.pathname.startsWith("/fiberOperations")) {
      setIsFiberSubmenuOpen(true);
    }
  }, [location]);

  const Messagedatalist = useSelector(
    (state) => state.messageSlice.messageList,
  );

  const VoIpPlan =
    selectedAccount?.service_type_code === "FIBER"
      ? userAccountInfo?.user_accounts?.find(
          (span) => span.service_type_code === "VOIP",
        )
      : false;

  const CablePlan =
    selectedAccount?.service_type_code === "FIBER"
      ? userAccountInfo?.user_accounts?.find(
          (span) => span.service_type_code === "TV",
        )
      : false;

  const handleNavigation = (e, path) => {
    e.preventDefault();
    navigate(path);
    toggleAside(); // Close the mobile drawer
  };

  return (
    <div className="menu menu-column">
      {userLoginInfo?.userTypeCode === UserTypes.CENTRIC ? (
        <>
          <div className="cp menu-item">
            <span
              className={`menu-link ${location.pathname === "/" ? "active" : ""}`}
              onClick={(e) => {
                e.preventDefault();
                toggleSubmenu("isDashboardOpen");
              }}
            >
              <span className="menu-icon">
                <i className="fa-regular fa-house-blank"></i>
              </span>
              <span className="menu-title">Dashboards</span>
              <span className="menu-arrow">
                <i
                  className={`fa-light ${
                    openSubmenu === "isDashboardOpen"
                      ? "fa-chevron-up"
                      : "fa-chevron-down"
                  }`}
                ></i>
              </span>
            </span>
          </div>
          {openSubmenu === "isDashboardOpen" && (
            <div className="cp submenu">
              <span
                className={`submenu-link ${location.pathname === "/home" ? "active" : ""}`}
                onClick={(e) => {
                  handleNavigation(e, "/home");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-user-gear"></i>
                </span>
                <span className="submenu-title">Operations Summary</span>
              </span>

              <span
                className={`submenu-link ${location.pathname === "/" ? "active" : ""}`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-user-gear"></i>
                </span>
                <span className="submenu-title">Customer Data View</span>
              </span>

              <span
                className={`submenu-link ${location.pathname === "/analysis" ? "active" : ""}`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/analysis");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-analytics"></i>
                </span>
                <span className="submenu-title">Data Analysis</span>
              </span>
            </div>
          )}
        </>
      ) : (
        <>
          <div
            className="cp menu-item"
            onClick={(e) => {
              handleNavigation(e, "/");
            }}
          >
            <span
              className={`menu-link ${location.pathname === "/" ? "active" : ""}`}
              onClick={(e) => {
                handleNavigation(e, "/");
              }}
            >
              <span className="menu-icon">
                <i className="fa-regular fa-house-blank"></i>
              </span>
              <span className="menu-title">Main Dashboard</span>
            </span>
          </div>
        </>
      )}

      <div className="cp menu-item">
        <span
          className={`menu-link `}
          onClick={(e) => {
            e.preventDefault();
            toggleSubmenu("isManageAccountsSubmenuOpen");
          }}
        >
          <span className="menu-icon">
            <i className="fa-light fa-tasks"></i>
          </span>
          <span className="menu-title">Manage Accounts</span>
          <span className="menu-arrow">
            <i
              className={`fa-light ${
                openSubmenu === "isManageAccountsSubmenuOpen"
                  ? "fa-chevron-up"
                  : "fa-chevron-down"
              }`}
            ></i>
          </span>
        </span>

        {openSubmenu === "isManageAccountsSubmenuOpen" && (
          <div className="cp submenu">
            {getAcl(AclModule.ACCOUNTS)?.read && (
              <span
                className={`submenu-link ${location.pathname === "/subAccounts" ? "active" : ""}`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/subAccounts");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-user-gear"></i>
                </span>
                <span className="submenu-title">Service Accounts</span>
              </span>
            )}
            {getAcl(AclModule.MANAGEPAYMENT)?.read && (
              <span
                className={`submenu-link ${location.pathname === "/managePayment" ? "active" : ""}`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/managePayment");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-money-check-dollar-pen"></i>
                </span>
                <span className="submenu-title">Payment Methods</span>
              </span>
            )}
            {getAcl(AclModule.MANAGECONTACT)?.read && (
              <span
                className={`submenu-link ${
                  location.pathname === "/manageContacts" ? "active" : ""
                }`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/manageContacts");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-address-book"></i>
                </span>
                <span className="submenu-title">Manage Users</span>
              </span>
            )}
            {getAcl(AclModule.ACCOUNTPREF)?.read && (
              <span
                className={`submenu-link ${
                  location.pathname === "/managePreference" ? "active" : ""
                }`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/managePreference");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-users"></i>
                </span>
                <span className="submenu-title">Notification Preferences</span>
              </span>
            )}

            {getAcl(AclModule.FIBERSETTINGS)?.read && (
              <span
                className={`submenu-link ${location.pathname === "/fiber-service" ? "active" : ""}`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/fiber-service");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-wifi"></i>
                </span>
                <span className="submenu-title">Fiber Settings</span>
              </span>
            )}
            {getAcl(AclModule.SECURITYSETTINGS)?.read && (
              <span
                className={`submenu-link ${
                  location.pathname === "/securitySettings" ? "active" : ""
                }`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/securitySettings");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-key"></i>
                </span>
                <span className="submenu-title">Security Settings</span>
              </span>
            )}
          </div>
        )}
      </div>

      <div className="cp menu-item">
        <span
          className={`menu-link`}
          onClick={(e) => {
            e.preventDefault();
            dispatch(setCentricUser(false));
            toggleSubmenu("isPaymentSubmenuOpen");
          }}
        >
          <span className="menu-icon">
            <i className="fa-light fa-tasks"></i>
          </span>
          <span className="menu-title">Payments & Billing</span>
          <span className="menu-arrow">
            <i
              className={`fa-light ${
                openSubmenu === "isPaymentSubmenuOpen"
                  ? "fa-chevron-up"
                  : "fa-chevron-down"
              }`}
            ></i>
          </span>
        </span>

        {openSubmenu === "isPaymentSubmenuOpen" && (
          <div className="cp submenu">
            {getAcl(AclModule.PAYMENTHISTORY)?.read && (
              <span
                className={`submenu-link ${
                  location.pathname === "/paymentHistory" ? "active" : ""
                }`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/paymentHistory");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light  fa-money-from-bracket"></i>
                </span>
                <span className="submenu-title">Payment History</span>
              </span>
            )}
            {getAcl(AclModule.BILLINGHISTORY)?.read && (
              <span
                className={`submenu-link ${
                  location.pathname === "/billingHistory" ? "active" : ""
                }`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/billingHistory");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-clock-rotate-left"></i>
                </span>
                <span className="submenu-title">Billing Statements</span>
              </span>
            )}
            {getAcl(AclModule.TRANSACTIONHISTORY)?.read && (
              <span
                className={`submenu-link ${
                  location.pathname === "/transactionHistory" ? "active" : ""
                }`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/transactionHistory");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-money-check"></i>
                </span>
                <span className="submenu-title">Transaction History</span>
              </span>
            )}
          </div>
        )}
      </div>

      {userLoginInfo?.userTypeCode !== UserTypes.CUSTOMER &&
        userLoginInfo?.userTypeCode !== UserTypes.CENTRIC &&
        getAcl(AclModule.PROPERTIES)?.read && (
          <div className="cp menu-item">
            <span
              className={`menu-link ${location.pathname === "/properties" ? "active" : ""}`}
              onClick={(e) => {
                handleNavigation(e, "/properties");
              }}
            >
              <span className="menu-icon">
                <i className="fa-regular fa-building"></i>
              </span>
              <span className="menu-title">Properties</span>
            </span>
          </div>
        )}

      {/* {getAcl(AclModule.SERVICETICKET)?.read && (
        <div className="cp menu-item">
          <VoiceButton
            buttonType="LINK"
            className={`menu-link ${
              location.pathname === "/serviceTicket" ? "active" : ""
            }`}
            command="Create Service Ticket"
            onClick={(e) => {
              if (e) {
                e.preventDefault();
                handleNavigation(e,"/serviceTicket");
              } else {
                handleNavigation(e,"/serviceTicketCreate");
              }
            }}
          >
            <span className="menu-icon">
              <i className="fa-light fa-ticket"></i>
            </span>
            <span className="menu-title">Service Tickets</span>
          </VoiceButton>
        </div>
      )} */}

      {/* {userDetails?.userTypeCode === UserTypes.CENTRIC && (
        <div className="cp menu-item">
          <span
            className={`menu-link ${
              location.pathname.startsWith("/fiberOperations") ? "active" : ""
            }`}
            
            onClick={(e) => {
              e.preventDefault();
              toggleSubmenu("isFiberSubmenuOpen");
            }}
          >
            <span className="menu-icon">
              <i className="fa-light fa-tasks"></i>
            </span>
            <span className="menu-title">Fiber Operations</span>
            <span className="menu-arrow">
              <i
                className={`fa-light ${
                  openSubmenu === "isFiberSubmenuOpen"
                    ? "fa-chevron-up"
                    : "fa-chevron-down"
                }`}
              ></i>
            </span>
          </span>

     
          {openSubmenu === "isFiberSubmenuOpen" && (
            <div className="cp submenu">
              <span
                className={`submenu-link ${
                  location.pathname === "/fiberOperations/network"
                    ? "active"
                    : ""
                }`}
                
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation(e,"/fiberOperations/network");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-chart-line"></i>
                </span>
                <span className="submenu-title">Network</span>
              </span>

              <span
                className={`submenu-link ${
                  location.pathname === "/fiberOperations/subscriber"
                    ? "active"
                    : ""
                }`}
                
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation(e,"/fiberOperations/subscriber");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-user"></i>
                </span>
                <span className="submenu-title">Subscriber</span>
              </span>

              <span
                className={`submenu-link ${
                  location.pathname === "/fiberOperations/onts" ? "active" : ""
                }`}
                
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation(e,"/fiberOperations/onts");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-file-alt"></i>
                </span>
                <span className="submenu-title">ONTs</span>
              </span>
            </div>
          )}
        </div>
      )} */}

      {getAcl(AclModule.MESSAGEBOX)?.read && (
        <div className="cp menu-item">
          <span
            className={`menu-link ${location.pathname === "/messageCenter" ? "active" : ""}`}
            onClick={(e) => {
              dispatch(setCentricUser(false));
              handleNavigation(e, "/messageCenter");
            }}
          >
            <span className="menu-icon">
              <i className="fa-light fa-message"></i>
            </span>
            <span className="menu-title">
              Message Center{" "}
              <span className="indicator-m">
                {Messagedatalist.data?.length}
              </span>{" "}
            </span>
          </span>
        </div>
      )}

      <div className="cp menu-item">
        <span
          className={`menu-link`}
          onClick={(e) => {
            e.preventDefault();
            dispatch(setCentricUser(true));
            toggleSubmenu("isSupportSubmenuOpen");
          }}
        >
          <span className="menu-icon">
            <i className="fa-light fa-tasks"></i>
          </span>
          <span className="menu-title"> Support </span>
          <span className="menu-arrow">
            <i
              className={`fa-light ${
                openSubmenu === "isSupportSubmenuOpen"
                  ? "fa-chevron-up"
                  : "fa-chevron-down"
              }`}
            ></i>
          </span>
        </span>

        {openSubmenu === "isSupportSubmenuOpen" && (
          <div className="cp submenu">
            {/* <span
              className={`submenu-link ${chatActivate ? 'active' : ''}`}
              onClick={e => {
                e.preventDefault();
                dispatch(setActivatebot(true));
                toggleAside();
              }}
            >
              <span className="submenu-icon">
                <i className="fa-light  fa-headset"></i>
              </span>
              <span className="submenu-title">24/7 Virtual Assistance</span>
            </span> */}

            {getAcl(AclModule.SERVICETICKET)?.read && (
              <VoiceButton
                buttonType="LINK"
                className={`cp submenu-link ${
                  location.pathname === "/serviceTicketCreate" ? "active" : ""
                }`}
                command="Create Service Ticket"
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/serviceTicketCreate");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-paper-plane"></i>
                </span>
                <span className="submenu-title">New Service Request</span>
              </VoiceButton>
            )}
            {getAcl(AclModule.SERVICETICKET)?.read && (
              <span
                className={`submenu-link ${location.pathname === "/serviceTicket" ? "active" : ""}`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/serviceTicket");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-ticket"></i>
                </span>
                <span className="submenu-title">My Service Requests</span>
              </span>
            )}
            {/* {getAcl(AclModule.SERVICETICKET)?.read && (
              <span
                className={`submenu-link ${location.pathname === "/fiber-service" ? "active" : ""
                  }`}
                onClick={(e) => {
                  handleNavigation(e, "/fiber-service");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-wifi"></i>
                </span>
                <span className="submenu-title">Fiber service</span>
              </span>
            )} */}
            {getAcl(AclModule.RESOURCECENTER)?.read && (
              <span
                className={`submenu-link ${location.pathname === "/resourceCenter" ? "active" : ""}`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/resourceCenter");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-hotel"></i>
                </span>
                <span className="submenu-title">Resource Center</span>
              </span>
            )}

            {getAcl(AclModule.FAQs)?.read && (
              <span
                className={`submenu-link ${location.pathname === "/faq" ? "active" : ""}`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/faq");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-question"></i>
                </span>
                <span className="submenu-title">{"    "}FAQs</span>
              </span>
            )}

            {getAcl(AclModule.CONTACTUS)?.read && (
              <span
                className={`submenu-link ${location.pathname === "/contactUs" ? "active" : ""}`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/contactUs");
                }}
              >
                <span className="submenu-icon">
                  <i className="fa-light fa-phone"></i>
                </span>
                <span className="submenu-title">Contact Us</span>
              </span>
            )}
          </div>
        )}
      </div>

      {getAcl(AclModule.GASHISTORY)?.read &&
        selectedAccount?.service_type_code === ServiceType.GAS && (
          <div className="cp menu-item">
            <div className="cp menu-item">
              <span
                className={`menu-link ${location.pathname === "/gasUssageHistory" ? "active" : ""}`}
                onClick={(e) => {
                  dispatch(setCentricUser(false));
                  handleNavigation(e, "/gasUssageHistory");
                }}
              >
                <span className="menu-icon">
                  <i className="fa-solid fa-fire-flame-simple"></i>
                </span>
                <span className="menu-title">Gas Usage History</span>
              </span>
            </div>
          </div>
        )}

      {userLoginInfo?.userTypeCode === UserTypes.CENTRIC && (
        <div className="cp menu-item">
          <span
            className={`menu-link ${
              location.pathname.startsWith("/fiberOperations") ||
              location.pathname.startsWith("/messageQueue")
                ? "active"
                : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              dispatch(setCentricUser(false));
              toggleSubmenu("customerCare");
            }}
          >
            <span className="menu-icon">
              <i className="fa-light fa-tasks"></i>
            </span>
            <span className="menu-title">Customer Care</span>
            <span className="menu-arrow">
              <i
                className={`fa-light ${
                  openSubmenu === "customerCare"
                    ? "fa-chevron-up"
                    : "fa-chevron-down"
                }`}
              ></i>
            </span>
          </span>

          {openSubmenu === "customerCare" && (
            <>
              {userLoginInfo?.userTypeCode === UserTypes.CENTRIC && (
                <div className="menu-item1">
                  <span
                    className={`menu-link1 ${
                      location.pathname.startsWith("/fiberOperations") ||
                      opensubSubmenu === "isFiberSubmenuOpen"
                        ? "active"
                        : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(setCentricUser(true));
                      toggleSubsubmenu("isFiberSubmenuOpen");
                    }}
                  >
                    <span className="menu-icon">
                      <i className="fa-light fa-tasks"></i>
                    </span>
                    <span className="menu-title">Fiber Operations</span>
                    <span className="menu-arrow">
                      <i
                        className={`fa-light ${
                          opensubSubmenu === "isFiberSubmenuOpen"
                            ? "fa-chevron-up"
                            : "fa-chevron-down"
                        }`}
                      ></i>
                    </span>
                  </span>

                  {opensubSubmenu === "isFiberSubmenuOpen" && (
                    <div className="cp submenu">
                      {getAcl(AclModule.NETWORK)?.read && (
                        <span
                          className={`submenu-link ${
                            location.pathname === "/fiberOperations/network"
                              ? "active"
                              : ""
                          }`}
                          onClick={(e) => {
                            dispatch(setCentricUser(true));
                            handleNavigation(e, "/fiberOperations/network");
                          }}
                        >
                          <span className="submenu-icon">
                            <i className="fa-light fa-chart-line"></i>
                          </span>
                          <span className="submenu-title">Network</span>
                        </span>
                      )}
                      {getAcl(AclModule.SUBSCRIBER)?.read && (
                        <span
                          className={`submenu-link ${
                            location.pathname === "/fiberOperations/subscriber"
                              ? "active"
                              : ""
                          }`}
                          onClick={(e) => {
                            dispatch(setCentricUser(true));
                            handleNavigation(e, "/fiberOperations/subscriber");
                          }}
                        >
                          <span className="submenu-icon">
                            <i className="fa-light fa-user"></i>
                          </span>
                          <span className="submenu-title">Subscriber</span>
                        </span>
                      )}
                      {getAcl(AclModule.ONTS)?.read && (
                        <span
                          className={`submenu-link ${
                            location.pathname === "/fiberOperations/onts"
                              ? "active"
                              : ""
                          }`}
                          onClick={(e) => {
                            dispatch(setCentricUser(true));
                            handleNavigation(e, "/fiberOperations/onts");
                          }}
                        >
                          <span className="submenu-icon">
                            <i className="fa-light fa-file-alt"></i>
                          </span>
                          <span className="submenu-title">ONTs</span>
                        </span>
                      )}
                    </div>
                  )}
                </div>
              )}
              {getAcl(AclModule.MESSAGEQUEUE)?.read && (
                <div className="cp submenu">
                  <a
                  target="_blank"
                  rel="noreferrer"
                    href={`${process.env.REACT_APP_ENROLL_URL}?loginprov=sf`}
                    className="submenu-link"
                  >
                    <span className="submenu-icon">
                      <i class="fa-light fa-plus"></i>
                    </span>
                    <span className="submenu-title">Enroll New Customer</span>
                  </a>
                </div>
              )}
              {getAcl(AclModule.MESSAGEQUEUE)?.read && (
                <div className="cp submenu">
                  <span
                    onClick={(e) => {
                      setOpenSubsubmenu(null);
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/enrollmentApp");
                    }}
                    className={`submenu-link ${
                      location.pathname === "/enrollmentApp" ? "active" : ""
                    }`}
                  >
                    <span className="submenu-icon">
                      <i class="fa-light fa-globe"></i>
                    </span>
                    <span className="submenu-title">Enrollment App </span>
                  </span>
                </div>
              )}
              {getAcl(AclModule.MESSAGEQUEUE)?.read && (
                <div className="cp submenu">
                  <span
                    onClick={(e) => {
                      setOpenSubsubmenu(null);
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/messageQueue");
                    }}
                    className={`submenu-link ${
                      location.pathname === "/messageQueue" ? "active" : ""
                    }`}
                  >
                    <span className="submenu-icon">
                      <i className="fa-solid fa-gear"></i>
                    </span>
                    <span className="submenu-title">Message Queue</span>
                  </span>
                </div>
              )}
              {getAcl(AclModule.MESSAGEQUEUE)?.read && (
                <div className="cp submenu">
                  <span
                    onClick={(e) => {
                      setOpenSubsubmenu(null);
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/manageFiberService");
                    }}
                    className={`submenu-link ${
                      location.pathname === "/manageFiberService"
                        ? "active"
                        : ""
                    }`}
                  >
                    <span className="submenu-icon">
                      <i className="fa-solid fa-layer-group"></i>
                    </span>
                    <span className="submenu-title">Manage Fiber Service</span>
                  </span>
                </div>
              )}
              {getAcl(AclModule.MESSAGEQUEUE)?.read && (
                <div className="cp submenu">
                  <span
                    onClick={(e) => {
                      setOpenSubsubmenu(null);
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/fiberEnrollmentIssue");
                    }}
                    className={`submenu-link ${
                      location.pathname === "/fiberEnrollmentIssue"
                        ? "active"
                        : ""
                    }`}
                  >
                    <span className="submenu-icon">
                      <i className="fa-solid fa-ticket"></i>
                    </span>
                    <span className="submenu-title">
                      Fiber Enrollment Issue
                    </span>
                  </span>
                </div>
              )}
              {getAcl(AclModule.ENTROLLMENTQUEUE)?.read && (
                <div className="cp submenu">
                  <span
                    className={`submenu-link ${
                      location.pathname === "/bulksmxsfupdate" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/bulksmxsfupdate");
                    }}
                  >
                    <span className="submenu-icon">
                      <i className="fa-light fa-list-alt"></i>
                    </span>
                    <span className="submenu-title">Bulk SMX data update </span>
                  </span>
                </div>
              )}
              {getAcl(AclModule.MESSAGEQUEUE)?.read && (
                <div className="cp submenu">
                  <span
                    onClick={(e) => {
                      setOpenSubsubmenu(null);
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/communityManagement");
                    }}
                    className={`submenu-link ${
                      location.pathname === "/communityManagement"
                        ? "active"
                        : ""
                    }`}
                  >
                    <span className="submenu-icon">
                      <i className="fa-solid fa-users"></i>
                    </span>
                    <span className="submenu-title">Manage Community </span>
                  </span>
                </div>
              )}

              {getAcl(AclModule.MANAGEDATAFILE)?.read &&
                userLoginInfo?.userTypeCode === UserTypes.CENTRIC && (
                  <div className="cp submenu">
                    <span
                      className={`submenu-link ${location.pathname === "/manageDocuments" ? "active" : ""}`}
                      onClick={(e) => {
                        dispatch(setCentricUser(true));
                        handleNavigation(e, "/manageDocuments");
                      }}
                    >
                      <span className="submenu-icon">
                        <i className="fa-light fa-file-check"></i>
                      </span>
                      <span className="submenu-title">Manage Data Files</span>
                    </span>
                  </div>
                )}
              {getAcl(AclModule.MANAGEMYACCOUNT)?.read && (
                <div className="cp submenu">
                  <span
                    onClick={(e) => {
                      setOpenSubsubmenu(null);
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/myAcclogin");
                    }}
                    className={`submenu-link ${location.pathname === "/myAcclogin" ? "active" : ""}`}
                  >
                    <span className="submenu-icon">
                      <i className="fa-solid fa-bars-progress"></i>
                    </span>
                    <span className="submenu-title">
                      Manage MyAccount Logins
                    </span>
                  </span>
                </div>
              )}
              {getAcl(AclModule.DUNNINGDISCONNECTS)?.read && (
                <div className="cp submenu">
                  <span
                    className={`submenu-link ${
                      location.pathname === "/disconnection" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/disconnection");
                    }}
                  >
                    <span className="submenu-icon">
                      <i className="fa-light fa-power-off"></i>
                    </span>
                    <span className="submenu-title">Dunning Disconnects</span>
                  </span>
                </div>
              )}
              {getAcl(AclModule.DUNNINGDISCONNECTS)?.read && (
                <div className="cp submenu">
                  <span
                    className={`submenu-link ${
                      location.pathname === "/dailySales" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/dailySales");
                    }}
                  >
                    <span className="submenu-icon">
                      <i className="fa-light fa-chart-area"></i>
                    </span>
                    <span className="submenu-title">Daily Sales</span>
                  </span>
                </div>
              )}
              {getAcl(AclModule.DUNNINGDISCONNECTS)?.read && (
                <div className="cp submenu">
                  <span
                    className={`submenu-link ${
                      location.pathname === "/reportGeneration" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/reportGeneration");
                    }}
                  >
                    <span className="submenu-icon">
                      <i className="fa-light fa-file-zipper"></i>
                    </span>
                    <span className="submenu-title">Report Generation</span>
                  </span>
                </div>
              )}
              {/* {getAcl(AclModule.ACCOUNTDEPOSITS)?.read && (
                <div className="cp submenu">
                  <span
                    className={`submenu-link ${location.pathname === '/depositAccounts' ? 'active' : ''
                      }`}
                    onClick={e => {
                      dispatch(setCentricUser(true));
                      handleNavigation(e, '/depositAccounts');
                    }}
                  >
                    <span className="submenu-icon">
                      <i className="fa-light fa-file-invoice-dollar"></i>
                    </span>
                    <span className="submenu-title">Account Deposits</span>
                  </span>
                </div>
              )} */}
              {getAcl(AclModule.CREDITADJUSTMENTS)?.read && (
                <div className="cp submenu">
                  <span
                    className={`submenu-link ${location.pathname === "/issueCredit" ? "active" : ""}`}
                    onClick={(e) => {
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/issueCredit");
                    }}
                  >
                    <span className="submenu-icon">
                      <i className="fa-light fa-comments-dollar"></i>
                    </span>
                    <span className="submenu-title">Credit Adjustments</span>
                  </span>
                </div>
              )}
              {getAcl(AclModule.ENTROLLMENTQUEUE)?.read && (
                <div className="cp submenu">
                  <span
                    className={`submenu-link ${
                      location.pathname === "/enrollmentQueue" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/enrollmentQueue");
                    }}
                  >
                    <span className="submenu-icon">
                      <i className="fa-light fa-list"></i>
                    </span>
                    <span className="submenu-title">Enrollment Queue</span>
                  </span>
                </div>
              )}
            </>
          )}
        </div>
      )}

      {CablePlan && (
        <div className="cp menu-item">
          <span
            onClick={(e) => {
              dispatch(setCentricUser(false));
              handleNavigation(e, "/tvPin");
            }}
            className={`menu-link ${location.pathname === "/tvPin" ? "active" : ""}`}
          >
            <span className="menu-icon">
              <i className="fa-light fa-tv-retro"></i>
            </span>
            <span className="menu-title">TV &amp; GigaStream™</span>
          </span>
        </div>
      )}
      {VoIpPlan && (
        <div className="cp menu-item">
          <a
            className={`menu-link ${location.pathname === "/alianza" ? "active" : ""}`}
            href="https://gigacall.user.alianza.com/login"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="menu-icon">
              <i className="fa-brands fa-teamspeak"></i>
            </span>
            <span className="menu-title">VOIP Alianza</span>
          </a>
        </div>
      )}

      {userLoginInfo?.userTypeCode === UserTypes.CENTRIC && (
        <div className="cp menu-item">
          <span
            className={`menu-link ${location.pathname === "/manageAnnouncements" ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              dispatch(setCentricUser(true));
              toggleSubmenu("isAdminOpen");
            }}
          >
            <span className="menu-icon">
              <i className="fa-light fa-tasks"></i>
            </span>
            <span className="menu-title">Admin</span>
            <span className="menu-arrow">
              <i
                className={`fa-light ${
                  openSubmenu === "isAdminOpen"
                    ? "fa-chevron-up"
                    : "fa-chevron-down"
                }`}
              ></i>
            </span>
          </span>

          {openSubmenu === "isAdminOpen" && (
            <>
              {getAcl(AclModule.ACCESSCONTROL)?.read && (
                <div className="cp submenu">
                  <span
                    onClick={(e) => {
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/admin/settings");
                    }}
                    className={`submenu-link ${
                      location.pathname === "/admin/settings" ? "active" : ""
                    }`}
                  >
                    <span className="submenu-icon">
                      <i className="fa-solid fa-gear"></i>
                    </span>
                    <span className="submenu-title">Access Control</span>
                  </span>
                </div>
              )}
              {getAcl(AclModule.MANAGEINTERNALUSERS)?.read && (
                <div className="cp submenu">
                  <span
                    className={`submenu-link ${
                      location.pathname === "/manage-myaccount-users"
                        ? "active"
                        : ""
                    }`}
                    onClick={(e) => {
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/manage-myaccount-users");
                    }}
                  >
                    <span className="submenu-icon">
                      <i className="fa-light fa-users"></i>
                    </span>
                    <span className="submenu-title">Manage Internal Users</span>
                  </span>
                </div>
              )}
              {getAcl(AclModule.MANAGEANNOUNCEMENTS)?.read && (
                <div className="cp submenu">
                  <span
                    className={`submenu-link ${
                      location.pathname === "/manageAnnouncements"
                        ? "active"
                        : ""
                    }`}
                    onClick={(e) => {
                      dispatch(setCentricUser(true));
                      handleNavigation(e, "/manageAnnouncements");
                    }}
                  >
                    <span className="submenu-icon">
                      <i className="fa-light fa-bullhorn"></i>
                    </span>
                    <span className="submenu-title">Manage Announcements</span>
                  </span>
                </div>
              )}
            </>
          )}
        </div>
      )}

      {/* {getAcl(AclModule.PAYMENTREGADMIN)?.read && (
        <div className="cp menu-item">
          <span
            onClick={e => {
              handleNavigation(e, '/pradmin');
            }}
            className={`menu-link ${location.pathname === '/pradmin' ? 'active' : ''}`}
          >
            <span className="menu-icon">
              <i className="fa-regular fa-message-bot"></i>
            </span>
            <span className="menu-title">Payment Registration Admin</span>
          </span>
        </div>
      )}
      {getAcl(AclModule.PAYMENTREGADMIN)?.read && (
        <div className="cp menu-item">
          <span
            onClick={e => {
              handleNavigation(e, '/pracc');
            }}
            className={`menu-link ${location.pathname === '/pracc' ? 'active' : ''}`}
          >
            <span className="menu-icon">
              <i className="fa-regular fa-user-plus"></i>
            </span>
            <span className="menu-title">Account Creation</span>
          </span>
        </div>
      )} */}
    </div>
  );
};

export default LeftMenu;
